import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class WallStructures extends Component {
  render() {
    return (
      <EntityList apiRoute='api/wallstructures' title='Remorque - Structures de mur' editTitle='Structure de mur' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default WallStructures;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/wallStructures.js
 **/